import React from "react";
import { Button } from "@/components/ui/button";

interface BrandImportModalFooterProps {
  onClose: () => void;
  onImport: () => void;
  validCount: number;
  isUploading: boolean;
}

export const BrandImportModalFooter: React.FC<BrandImportModalFooterProps> = ({
  onClose,
  onImport,
  validCount,
  isUploading,
}) => {
  return (
    <div className="flex justify-end space-x-3 pt-4 border-t">
      <Button variant="outline" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onImport}
        disabled={validCount === 0 || isUploading}
        className="bg-purple-600 hover:bg-purple-700"
      >
        {isUploading ? "Importing..." : `Import ${validCount} Brands`}
      </Button>
    </div>
  );
};
